import React from "react";
import { Card, Tabs } from "antd";
import { connect } from "dva";
import InfoPane from "./InfoPane";

const { TabPane } = Tabs;

const parseShipperData = shipmentData => {
  if (!shipmentData) return null;

  const parsedShipperInfo = {
    entity: {
      name: shipmentData.dealer.name,
      address: shipmentData.dealer.completedAddress,
      phoneNumber: shipmentData.dealer.phoneNumber,
      phoneExtension: shipmentData.dealer.phoneNumberExtension,
      type: "Shipper",
    },
    user: {
      fullName: shipmentData?.contactShipperFullName || "",
      email: shipmentData?.contactShipperEmail || "",
      phoneNumber: shipmentData?.contactShipperPhoneNumber || "",
      phoneExtension: shipmentData?.contactShipperPhoneNumberExtension || "",
    },
  };

  return parsedShipperInfo;
};

const parseTransporterData = loadData => {
  if (!loadData?.transporter) return null;

  const parsedTransporterInfo = {
    entity: {
      name: loadData?.transporter?.name,
      address: loadData?.transporter?.completedAddress,
      phoneNumber: loadData?.transporter?.phoneNumber,
      phoneExtension: loadData?.transporter?.phoneNumberExtension,
      type: "Transporter",
    },
    user: {
      fullName: loadData?.userFullName,
      email: loadData?.userEmail,
      phoneNumber: loadData?.userPhoneNumber,
    },
  };

  return parsedTransporterInfo;
};

const ShipperAndTransporterInfo = props => {
  const { shipmentData } = props;

  return (
    <Card style={{ minHeight: 400, marginBottom: 16 }} bodyStyle={{ padding: 0 }}>
      <Tabs defaultActiveKey="1" className="dealerShipmentCardTabs">
        <TabPane tab={<span style={{ padding: 12 }}>Shipper Info</span>} key="1">
          <InfoPane parsedInfo={parseShipperData(shipmentData)} />
        </TabPane>
        <TabPane tab="Transporter Info" key="2">
          <InfoPane parsedInfo={parseTransporterData(shipmentData?.load)} />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default connect(({ shipmentDetails }) => ({
  shipmentData: shipmentDetails.data,
}))(ShipperAndTransporterInfo);
